module.exports = __webpack_public_path__ + "img/billboard_icon.5980672d.png";